const lowlightMimeTypeToLangMap = {
  "application/json": "json",
  "text/html": "html"
};
const veryBigCodeSize = 80 * 1e4;
const storeableCodeHighlights = 1e3;

export { lowlightMimeTypeToLangMap, storeableCodeHighlights, veryBigCodeSize };
//# sourceMappingURL=code.config.js.map
